module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: _vm.labelClass,
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5",
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "end"
    },
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID + '_user',
      "name": _vm.fieldID + '_user',
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValueUser
    },
    on: {
      "input": function($event) {
        _vm.updateValueUser($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "text-align": "center"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center",
      "color": "black",
      "padding": "0px"
    },
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID + '_at',
      "name": _vm.fieldID + '_at',
      "value": "@",
      "readonly": true,
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  }, [(_vm.isDisabled) ? _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "end"
    },
    style: (_vm.vSelectFiledDisabledStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID + '_domain_disabled',
      "name": _vm.fieldID + '_domain_disabled',
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValue
    }
  }) : _c('v-select', {
    staticClass: "style-chooser-email",
    style: (_vm.vSelectFiledStyle),
    attrs: {
      "noDrop": _vm.isDisabled,
      "clearable": false,
      "options": _vm.fieldOptions,
      "single-line": true,
      "value": _vm.fieldValue,
      "taggable": true
    },
    on: {
      "input": _vm.updateValueDomainOption
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n        Manual input\n      ")])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459ef818","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/email-box.vue
// module id = 976
// module chunks = 0